import { InsureIQLrpCommodityNames } from '@harvestiq/constants';
import { z } from '@harvestiq/zod';
import { zIsoDate } from '@harvestiq/zod';

export const lrpOptionsRequestSchema = z.object({
  commodity: z.nativeEnum(InsureIQLrpCommodityNames),
  marketingDate: zIsoDate(),
  optionType: z.string(),
  minCoveragePrice: z.coerce.number(),
  maxCoveragePrice: z.coerce.number(),
});

export type LrpOptionsRequest = z.infer<typeof lrpOptionsRequestSchema>;
